import React from "react";
import ReactDOM from "react-dom/client";
import ReactModal from "react-modal";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./helper/i18n_init";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
ReactModal.setAppElement(document.getElementById("root"));

root.render(<App />);
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
